import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=ada6c37a&"
import script from "./addStore.vue?vue&type=script&lang=js&"
export * from "./addStore.vue?vue&type=script&lang=js&"
import style0 from "./addStore.vue?vue&type=style&index=0&id=ada6c37a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports